import common from '../../common';

const reasonCodes = common.domain.formOperationalCompletenessReasonCodes;

const messages = {
   [reasonCodes.REPEATER_TYPE_UNKNOWN]: 'Repeater type is not recognised.',
   [reasonCodes.REPEATER_ENTRY_MODE_UNKNOWN]: 'Entry mode is not recognised.',
   [reasonCodes.REPEATER_ENTRY_MODE_NOT_ALLOWED_FOR_TYPE]: 'Entry mode is not valid for this Repeater type.',
   [reasonCodes.LIST_REPEATER_ENTRY_MODE_REQUIRED]: 'Select how entries should be created.',
   [reasonCodes.LIST_REPEATER_FULL_LIST_FIELDS_CONFLICT]: 'Full list has incompatible entry requirements.',
   [reasonCodes.LIST_REPEATER_ADD_ENTRIES_CADENCE_INVALID]: 'Select a valid entry requirement.',
   [reasonCodes.LIST_REPEATER_ADD_ENTRIES_COUNT_INVALID]: 'Enter a valid number of entries.',
   [reasonCodes.LIST_REPEATER_BINDING_MISSING]: 'Select a datasource.',
   [reasonCodes.LIST_REPEATER_BINDING_MALFORMED]: 'Datasource selection is invalid.',
   [reasonCodes.LIST_REPEATER_DATASOURCE_NOT_FOUND]: 'The selected datasource is no longer available.',
   [reasonCodes.LIST_REPEATER_DATASOURCE_INACCESSIBLE]: 'You cannot use the selected datasource.',
   [reasonCodes.LIST_REPEATER_DATASOURCE_RESOLUTION_FAILED]: 'The datasource could not be resolved for Preview.'
};

export default function mapFormOperationalErrors({ errors, items }) {
   const byId = new Map((items || []).map((item) => [String(item.id), item]));

   return (errors || []).map((error) => {
      const item = byId.get(String(error.idFormItem));
      const label = item && item.label ? item.label : `Repeater #${error.idFormItem}`;
      const message = messages[error.reasonCode] || 'Repeater configuration is not operational.';
      return { idFormItem: error.idFormItem, label, message };
   });
}
